import { Component, Inject } from '@angular/core';

@Component({
  selector: 'ut-unified-already-signed-in-error',
  templateUrl: './already-signed-in.component.html',
  standalone: false,
})
export class UnifiedAlreadySignedInComponent {
  constructor(@Inject('$window') private $window: any) { }

  goToLogin(): void {
    this.$window.location.href = '/login';
  }
}

export default UnifiedAlreadySignedInComponent;
